/* bambusa-wishlist.js — Favoris & Historique de quiz (Bambusa)
   Rétention : les FAVORIS n'expirent jamais (le cycle d'achat est saisonnier —
   un coup de cœur en juillet se plante en novembre). Seul l'HISTORIQUE DE QUIZ,
   qui s'écrit tout seul, est limité : 3 dernières sessions et 90 jours. */
(function () {
  'use strict';

  /* Le script est appelé dans theme.liquid : on neutralise toute double initialisation. */
  if (window.BambusaWishlist) return;

  var FAVS_KEY   = 'bw_fav_v1';
  var QUIZ_KEY   = 'bw_quiz_v1';
  var QUIZ_MAX   = 3;
  var QUIZ_TTL   = 90 * 24 * 60 * 60 * 1000;

  /* ── Utilitaires ──────────────────────────────────────── */
  function read(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) { return fallback; }
  }

  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (e) { return false; }
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function signature(answers) {
    return Object.keys(answers || {}).sort().map(function (k) {
      return k + ':' + answers[k];
    }).join('|');
  }

  function trimProduct(p) {
    return {
      handle: p.handle,
      n: p.n || p.name || '',
      fam: p.fam || '',
      desc: p.desc || '',
      image: p.image || ''
    };
  }

  function freshQuizzes() {
    var list = read(QUIZ_KEY, []);
    if (!Array.isArray(list)) list = [];
    var cutoff = Date.now() - QUIZ_TTL;
    return list.filter(function (q) { return q && q.date && q.date > cutoff; });
  }

  /* ── API publique ─────────────────────────────────────── */
  var W = {
    /* Favoris — sans expiration, volontairement. */
    getFavorites: function () {
      var f = read(FAVS_KEY, {});
      return (f && typeof f === 'object' && !Array.isArray(f)) ? f : {};
    },

    has: function (handle) { return !!this.getFavorites()[handle]; },

    count: function () { return Object.keys(this.getFavorites()).length; },

    add: function (handle, data) {
      if (!handle) return false;
      var favs = this.getFavorites();
      var prev = favs[handle] || {};
      favs[handle] = Object.assign({}, prev, data || {}, {
        handle: handle,
        addedAt: prev.addedAt || Date.now()
      });
      write(FAVS_KEY, favs);
      this._emit();
      return true;
    },

    /* Ajout groupé depuis les résultats du quiz : ignore ce qui est déjà là. */
    addMany: function (items) {
      var favs = this.getFavorites();
      var added = 0;
      (items || []).forEach(function (it) {
        if (!it || !it.handle || favs[it.handle]) return;
        favs[it.handle] = Object.assign({}, trimProduct(it), { addedAt: Date.now() });
        added++;
      });
      if (added) { write(FAVS_KEY, favs); this._emit(); }
      return added;
    },

    remove: function (handle) {
      var favs = this.getFavorites();
      delete favs[handle];
      write(FAVS_KEY, favs);
      this._emit();
    },

    toggle: function (handle, data) {
      if (this.has(handle)) { this.remove(handle); return false; }
      this.add(handle, data);
      return true;
    },

    /* Historique de quiz — purgé à la lecture, numéroté à l'affichage. */
    getQuizzes: function () {
      var list = freshQuizzes();
      var kept = list.slice(-QUIZ_MAX);
      if (kept.length !== (read(QUIZ_KEY, []) || []).length) write(QUIZ_KEY, kept);
      return kept.map(function (q, i) {
        return Object.assign({}, q, { num: i + 1 });
      });
    },

    /* Rejouer le quiz avec les mêmes réponses remplace l'entrée au lieu d'en empiler une. */
    saveQuiz: function (answers, products, labels) {
      var list = freshQuizzes();
      var sig = signature(answers);
      var entry = {
        sig: sig,
        date: Date.now(),
        answers: answers || {},
        labels: labels || {},
        products: (products || []).map(trimProduct)
      };
      var last = list[list.length - 1];
      if (last && last.sig === sig) list[list.length - 1] = entry;
      else list.push(entry);
      list = list.slice(-QUIZ_MAX);
      write(QUIZ_KEY, list);
      this._emit();
      return list.length;
    },

    _emit: function () {
      document.dispatchEvent(new CustomEvent('bw:changed'));
    }
  };

  window.BambusaWishlist = W;

  /* ── Styles ───────────────────────────────────────────── */
  var css = [
    '#bw-toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(16px);background:#1a1a1a;color:#fff;padding:11px 22px;border-radius:8px;font-size:13px;opacity:0;transition:all .3s;z-index:9999;pointer-events:none;white-space:nowrap}',
    '#bw-toast.bw-on{opacity:1;transform:translateX(-50%) translateY(0)}',
    '.bw-heart-wrap{margin-top:10px}',
    '.bw-heart-btn{display:inline-flex;align-items:center;gap:7px;background:none;border:1px solid #e5e7eb;border-radius:8px;padding:10px 16px;cursor:pointer;font-size:13px;color:#6b7280;transition:all .2s;font-family:inherit}',
    '.bw-heart-btn:hover,.bw-heart-btn--active{border-color:#e05454;color:#e05454}',
    '.bw-heart-btn--active{background:#fef2f2}',
    '.bw-heart-btn--active svg{fill:#e05454}',
    '.bw-heart-btn svg{transition:fill .2s;flex-shrink:0}',
    '.bq-heart{position:absolute;top:8px;right:8px;background:none;border:none;cursor:pointer;padding:5px;color:#d1d5db;transition:color .2s;line-height:1;z-index:2}',
    '.bq-heart:hover,.bq-heart--on{color:#e05454}',
    '.bq-heart--on svg{fill:#e05454}',
    '#bw-account{padding-top:2rem;border-top:1px solid #e5e7eb;margin-top:2rem}',
    '#bw-account h2{font-size:20px;font-weight:600;margin-bottom:1rem}',
    '.bw-tabs{display:flex;flex-wrap:wrap;gap:0;margin-bottom:1.5rem;border-bottom:2px solid #e5e7eb}',
    '.bw-tab{background:none;border:none;cursor:pointer;padding:9px 18px;font-size:13px;font-weight:600;color:#6b7280;border-bottom:2px solid transparent;margin-bottom:-2px;transition:all .2s;font-family:inherit;white-space:nowrap}',
    '.bw-tab:hover{color:#1D9E75}',
    '.bw-tab--active{color:#1D9E75;border-bottom-color:#1D9E75}',
    '.bw-panel{display:none}.bw-panel--active{display:block}',
    '.bw-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(190px,1fr));gap:12px}',
    '.bw-card{background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:14px;display:flex;flex-direction:column;position:relative;overflow:hidden}',
    '.bw-card-img{display:block;width:calc(100% + 28px);height:150px;object-fit:cover;margin:-14px -14px 12px;border-radius:12px 12px 0 0}',
    '.bw-card-fam{font-size:10px;color:#9ca3af;text-transform:uppercase;letter-spacing:.06em;margin:0 0 3px}',
    '.bw-card-name{font-size:13px;font-weight:600;font-style:italic;margin:0 0 6px}',
    '.bw-card-desc{font-size:12px;color:#6b7280;line-height:1.5;margin:0 0 10px;flex:1}',
    '.bw-card-link{display:inline-flex;align-items:center;gap:4px;font-size:12px;color:#1D9E75;font-weight:600;text-decoration:none;margin-top:auto}',
    '.bw-card-rm{position:absolute;top:8px;right:8px;background:rgba(255,255,255,.92);border:none;cursor:pointer;color:#9ca3af;font-size:16px;line-height:1;padding:3px 7px;border-radius:6px;z-index:2}',
    '.bw-card-rm:hover{color:#e05454;background:#fef2f2}',
    '.bw-empty{color:#6b7280;font-size:14px;padding:.75rem 0}',
    '.bw-quiz-meta{display:flex;justify-content:space-between;align-items:center;margin-bottom:.6rem;flex-wrap:wrap;gap:8px}',
    '.bw-quiz-num{font-weight:600;font-size:14px}',
    '.bw-quiz-date{font-size:12px;color:#9ca3af}',
    '.bw-quiz-tags{display:flex;flex-wrap:wrap;gap:5px;margin-bottom:.85rem}',
    '.bw-quiz-tag{font-size:11px;padding:3px 10px;border-radius:20px;background:#E1F5EE;color:#0F6E56}',
    '.bw-addall{background:#1D9E75;border:none;border-radius:8px;padding:8px 16px;cursor:pointer;font-size:12px;font-weight:600;color:#fff;font-family:inherit}',
    '.bw-addall:hover{opacity:.9}',
    '.bw-note{font-size:11px;color:#9ca3af;margin-top:1.25rem;line-height:1.5}'
  ].join('');

  var styleEl = document.createElement('style');
  styleEl.id = 'bw-styles';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  /* ── Toast ────────────────────────────────────────────── */
  /* Pictos autorisés dans le toast. On ne passe JAMAIS de HTML à bwToast :
     le 2e argument est une CLÉ de cette table ('coeur', 'coche', 'croix'),
     le message, lui, reste toujours traité comme du texte. */
  var BW_ICONS = {
    coeur: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" style="width:1.05em;height:1.05em;vertical-align:-.16em;display:inline-block"><g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round"><path d="M12 20.6c-1.6-1-8.4-5.4-8.4-11A4.6 4.6 0 0 1 12 7a4.6 4.6 0 0 1 8.4 2.6c0 5.6-6.8 10-8.4 11Z"/></g></svg>',
    'coeur-plein': '<span style="color:#ca9805"><svg class="bb-pic-plein" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" style="width:1.05em;height:1.05em;vertical-align:-.16em;display:inline-block"><g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round"><path d="M12 20.6c-1.6-1-8.4-5.4-8.4-11A4.6 4.6 0 0 1 12 7a4.6 4.6 0 0 1 8.4 2.6c0 5.6-6.8 10-8.4 11Z"/></g></svg></span>',
    coche: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" style="width:1.05em;height:1.05em;vertical-align:-.16em;display:inline-block"><g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round"><path d="M4.4 12.6c1.8 1.4 3.4 3.1 4.8 5 3-4.6 6.4-8.5 10.4-11.8"/></g></svg>',
    croix: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" style="width:1.05em;height:1.05em;vertical-align:-.16em;display:inline-block"><g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round"><path d="M6.4 6.4 17.6 17.6M17.6 6.4 6.4 17.6"/></g></svg>'
  };

  function toast(msg, icon) {
    var el = document.getElementById('bw-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'bw-toast';
      document.body.appendChild(el);
    }
    el.textContent = '';
    if (icon && BW_ICONS[icon]) {
      var moule = document.createElement('template');
      moule.innerHTML = BW_ICONS[icon];
      var picto = moule.content ? moule.content.firstElementChild : null;
      if (!picto) {                     /* repli : navigateur sans <template> */
        var jetable = document.createElement('span');
        jetable.innerHTML = BW_ICONS[icon];
        picto = jetable.firstElementChild;
      }
      if (picto) {
        el.appendChild(picto);
        el.appendChild(document.createTextNode(' '));
      }
    }
    el.appendChild(document.createTextNode(msg));
    el.classList.add('bw-on');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('bw-on'); }, 2600);
  }
  window.bwToast = toast;

  function heartSVG(size) {
    size = size || 18;
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
  }
  window.bwHeartSVG = heartSVG;

  /* ── Cœur sur la fiche produit ────────────────────────── */
  function initProductHeart() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.getElementById('bw-prod-heart')) return;

    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    var handle = m ? m[1] : null;
    if (!handle) return;

    var titleEl = document.querySelector('.product__title, .product-single__title, [itemprop="name"]');
    var name = ((titleEl || {}).textContent || handle).trim();
    var famEl = document.querySelector('.product__type, .product-single__vendor');
    var fam = famEl ? famEl.textContent.trim() : '';
    var imgEl = document.querySelector('.product-featured-img, .product__photo img, product-media img');
    var image = imgEl ? (imgEl.currentSrc || imgEl.src || '') : '';

    var isFav = W.has(handle);

    var btn = document.createElement('button');
    btn.id = 'bw-prod-heart';
    btn.type = 'button';
    btn.className = 'bw-heart-btn' + (isFav ? ' bw-heart-btn--active' : '');
    btn.setAttribute('aria-label', 'Ajouter aux favoris');
    btn.innerHTML = heartSVG() + '<span>' + (isFav ? 'Dans mes favoris' : 'Ajouter aux favoris') + '</span>';

    btn.addEventListener('click', function () {
      var on = W.toggle(handle, { n: name, fam: fam, image: image });
      btn.classList.toggle('bw-heart-btn--active', on);
      btn.querySelector('span').textContent = on ? 'Dans mes favoris' : 'Ajouter aux favoris';
      toast(on ? 'Ajouté aux favoris' : 'Retiré des favoris', on ? 'coeur-plein' : 'coeur');
    });

    var wrap = document.createElement('div');
    wrap.className = 'bw-heart-wrap';
    wrap.appendChild(btn);

    var anchor = document.querySelector(
      'product-form, .product-form__controls-group--submit, .product-form__submit, .shopify-payment-button, [name="add"]'
    );
    if (anchor) {
      var parent = anchor.closest('product-form') || anchor.parentNode;
      parent.parentNode.insertBefore(wrap, parent.nextSibling);
    }
  }

  /* ── Page compte ──────────────────────────────────────── */
  function initAccount() {
    var container = document.getElementById('bw-account');
    if (!container || container._bwInit) return;
    container._bwInit = true;

    var shopUrl = (container.getAttribute('data-shop') || '').replace(/\/$/, '');

    function productCard(p, opts) {
      opts = opts || {};
      var handle = p.handle || '';
      var link = shopUrl + '/products/' + handle;
      var html = '<div class="bw-card">';
      if (opts.removable) {
        html += '<button class="bw-card-rm" data-rm="' + esc(handle) + '" type="button" title="Retirer des favoris" aria-label="Retirer des favoris">×</button>';
      }
      if (opts.favable) {
        var on = W.has(handle);
        html += '<button class="bq-heart' + (on ? ' bq-heart--on' : '') + '" type="button"' +
          ' data-fav="' + esc(handle) + '" data-quiz="' + esc(opts.quizIndex) + '"' +
          ' title="' + (on ? 'Retirer des favoris' : 'Ajouter aux favoris') + '">' + heartSVG(16) + '</button>';
      }
      if (p.image) {
        html += '<img class="bw-card-img" src="' + esc(p.image) + '" alt="' + esc(p.n || handle) + '" loading="lazy">';
      }
      if (p.fam) html += '<p class="bw-card-fam">' + esc(p.fam) + '</p>';
      html += '<p class="bw-card-name">' + esc(p.n || handle) + '</p>';
      if (p.desc) html += '<p class="bw-card-desc">' + esc(p.desc) + '</p>';
      html += '<a class="bw-card-link" href="' + link + '">Voir dans la boutique →</a>';
      html += '</div>';
      return html;
    }

    function render() {
      var favs = W.getFavorites();
      var quizzes = W.getQuizzes();
      var activeId = (container.querySelector('.bw-tab--active') || {}).dataset;
      activeId = activeId ? activeId.panel : 'bwp-favs';

      var favList = Object.keys(favs).map(function (k) { return favs[k]; }).sort(function (a, b) {
        return (b.addedAt || 0) - (a.addedAt || 0);
      });

      var html = '<h2>Mes Favoris</h2><div class="bw-tabs">' +
        '<button class="bw-tab" data-panel="bwp-favs">' + BW_ICONS['coeur-plein'] + ' Produits aimés' +
        (favList.length ? ' (' + favList.length + ')' : '') + '</button>' +
        quizzes.map(function (q) {
          return '<button class="bw-tab" data-panel="bwp-quiz-' + (q.num - 1) + '">Mon quiz #' + q.num + '</button>';
        }).join('') +
        '</div>';

      html += '<div class="bw-panel" id="bwp-favs">' + (
        favList.length === 0
          ? '<p class="bw-empty">Pas encore de favoris — cliquez ' + BW_ICONS['coeur-plein'] + ' sur une fiche produit ou sur les résultats du quiz pour en ajouter.</p>'
          : '<div class="bw-grid">' + favList.map(function (p) {
              return productCard(p, { removable: true });
            }).join('') + '</div>'
      ) + '</div>';

      quizzes.forEach(function (q, i) {
        var dateStr = new Date(q.date).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
        var tags = Object.keys(q.labels || {}).map(function (k) { return q.labels[k]; })
          .filter(Boolean).map(function (v) {
            return '<span class="bw-quiz-tag">' + esc(v) + '</span>';
          }).join('');
        var cards = (q.products || []).map(function (p) {
          return productCard(p, { favable: true, quizIndex: i });
        }).join('');

        html += '<div class="bw-panel" id="bwp-quiz-' + i + '">' +
          '<div class="bw-quiz-meta">' +
            '<span class="bw-quiz-num">Quiz #' + q.num + '</span>' +
            '<span class="bw-quiz-date">' + dateStr + '</span>' +
          '</div>' +
          (tags ? '<div class="bw-quiz-tags">' + tags + '</div>' : '') +
          ((q.products || []).length
            ? '<p style="margin-bottom:.85rem"><button class="bw-addall" data-addall="' + i + '" type="button">' + BW_ICONS['coeur-plein'] + ' Tout ajouter à mes favoris</button></p>' +
              '<div class="bw-grid">' + cards + '</div>'
            : '<p class="bw-empty">Aucun résultat sauvegardé.</p>') +
        '</div>';
      });

      html += '<p class="bw-note">Vos favoris sont conservés sans limite de durée sur cet appareil. ' +
        'L\'historique de quiz garde les ' + QUIZ_MAX + ' dernières sessions pendant 90 jours.</p>';

      container.innerHTML = html;

      /* On restaure l'onglet ouvert, sinon le premier. */
      var tab = container.querySelector('.bw-tab[data-panel="' + activeId + '"]') || container.querySelector('.bw-tab');
      var panel = container.querySelector('#' + (tab ? tab.dataset.panel : 'bwp-favs'));
      if (tab) tab.classList.add('bw-tab--active');
      if (panel) panel.classList.add('bw-panel--active');
    }

    /* Un seul écouteur, posé hors de render() : il ne s'accumule pas au fil des rendus. */
    container.addEventListener('click', function (e) {
      var tab = e.target.closest('.bw-tab');
      if (tab) {
        container.querySelectorAll('.bw-tab').forEach(function (t) { t.classList.remove('bw-tab--active'); });
        container.querySelectorAll('.bw-panel').forEach(function (p) { p.classList.remove('bw-panel--active'); });
        tab.classList.add('bw-tab--active');
        var panel = container.querySelector('#' + tab.dataset.panel);
        if (panel) panel.classList.add('bw-panel--active');
        return;
      }

      var rm = e.target.closest('[data-rm]');
      if (rm) {
        W.remove(rm.getAttribute('data-rm'));
        toast('Retiré des favoris', 'coeur');
        return;
      }

      var addall = e.target.closest('[data-addall]');
      if (addall) {
        var qz = W.getQuizzes()[parseInt(addall.getAttribute('data-addall'), 10)];
        if (qz) {
          var n = W.addMany(qz.products);
          toast(n ? '' + n + ' plante' + (n > 1 ? 's ajoutées' : ' ajoutée') + ' aux favoris' : 'Déjà dans vos favoris', n ? 'coeur-plein' : null);
        }
        return;
      }

      var fav = e.target.closest('[data-fav]');
      if (fav) {
        var handle = fav.getAttribute('data-fav');
        var quiz = W.getQuizzes()[parseInt(fav.getAttribute('data-quiz'), 10)];
        var prod = quiz && (quiz.products || []).filter(function (p) { return p.handle === handle; })[0];
        var on = W.toggle(handle, prod || { handle: handle });
        toast(on ? 'Ajouté aux favoris' : 'Retiré des favoris', on ? 'coeur-plein' : 'coeur');
      }
    });

    render();
    document.addEventListener('bw:changed', render);
  }

  /* ── Démarrage ────────────────────────────────────────── */
  function boot() {
    initProductHeart();
    initAccount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
